<button mat-icon-button [matMenuTriggerFor]="appMenu" [style.visibility]="settings.showHeaderButtons ? '' : 'hidden'">
    <mat-icon>menu</mat-icon>
</button>


<!-- menu -->
<mat-menu #appMenu="matMenu">
        <button mat-menu-item routerLink="/scheduler" routerLinkActive="active">
            <mat-icon>schedule</mat-icon>{{ 'MENU.SCHEDULER' | translate}}
        </button>
    <button mat-menu-item routerLink="/search-customer" routerLinkActive="active">
        <mat-icon>search</mat-icon>{{ 'MENU.SEARCH-PATIENT' | translate}}
    </button>
    <!-- select business before -->
    <button mat-menu-item (click)="onNewCustomer($event)" [disabled]="!canSelectNewCustomerMenuItem">
        <mat-icon>create</mat-icon>{{ 'MENU.NEW-PATIENT' | translate}}
    </button>
    <button mat-menu-item routerLink="/waitlist" routerLinkActive="active">
        <mat-icon>update</mat-icon>{{ 'MENU.WAIT-LIST' | translate}}
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout($event)">
        <mat-icon>account_circle</mat-icon>{{ 'COMMON.LOGOUT' | translate}}
    </button>
</mat-menu>